import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore, writeBatch } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyBuujKyB9cYiInHwSn4x_UPPqLdcPCAqtI",
  authDomain: "luna-chat-app-20e79.firebaseapp.com",
  projectId: "luna-chat-app-20e79",
  storageBucket: "luna-chat-app-20e79.appspot.com",
  messagingSenderId: "237508715438",
  appId: "1:237508715438:web:7ec0fa158067c5de815e3f",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app);
const batch = writeBatch(db);
export { auth, db, storage, functions, batch };
